import { isElement, isString } from 'lodash';
import { getOptionsFromElement } from './utils';
import { Form } from './form';
import { LoginForm } from './loginForm';

export class Forms {
  forms = {};
  selector = '[data-form]';
  defaults = {
    form: {
      ajax: true,
      redirect: false,
      toastOnError: false,
      toastOnSuccess: false,
      lockoutOnRedirect: false,
      successMessage: false,
      showSuccessBlock: false,
      disableSubmit: false,
      formErrors: false,
      fieldErrors: true,
      highlightFieldErrors: true,
      offset: 20,
      confirmMessage: false,
      confirmationPopup: false,
      agreeTerms: false,
      errorMessage: false,
      termsMessage: false,
      onSubmit: () => {},
      onSuccess: () => {},
      onFail: () => {},
      selectors: {
        formWrapper: '[data-form-wrapper]',
        formErrors: '[data-form-errors]',
        field: '[data-form-field]',
        fieldRow: '[data-table-row], [data-matrix-block]', // for table fields and matrix fields with child fields
        submitWrapper: '[data-form-submit]',
        submit: 'input[type="submit"]',
        fieldError: '[data-form-field-error]',
        successBlock: '[data-form-success-block]',
        confirmationPopup: '#confirmation-popup',
      },
      hasErrorsClass: 'has-errors',
      hasErrorClass: 'has-error',
      fieldErrorClass: 'field-error',
      submittingClass: 'has-spinner',
    },
  };

  constructor() {
    this.initForms(document);
    let loginForm = document.getElementById('loginForm');
    if (loginForm) {
      this.create(loginForm, {}, LoginForm);
    }
    console.log('Forms initialised');
  }

  initForms(container) {
    let forms = container.querySelectorAll(this.selector);
    if (forms.length) {
      forms.forEach((form) => {
        this.create(form);
      });
    }
  }

  getForm(form) {
    if (isElement(form)) {
      form = form.id;
    }
    if (isString(form)) {
      return this.forms[form] || false;
    }
    return false;
  }

  create(element, options = {}, classs = Form) {
    if (!element.id) {
      throw new Error('Form element is missing id');
    }
    if (element.dataset.form) {
      console.log('Form ' + element.id + ' already initialised');
      return;
    }
    let settings = { ...this.defaults.form, ...getOptionsFromElement(element), ...options };
    element.setAttribute('data-form', '');
    let form = new classs(element, settings);
    element.dataset.form = form;
    this.addForm(element.id, form);
    return form;
  }

  addForm(id, form) {
    this.forms[id] = form;
  }

  resetAllForms(context) {
    let forms = (context || document).querySelectorAll('[data-form-id]');
    forms.forEach((form) => {
      form.reset();
    });
  }
}
